import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//animations
import { fadeAnimations } from './animations/fading.animation';

//components
import { AtramButtonComponent } from './components/atram-button/atram-button.component';
import { AtramTextboxComponent } from './components/atram-textbox/atram-textbox.component';
import { AtramOtpTextboxComponent } from './components/atram-otp-textbox/atram-otp-textbox.component';
import { AtramModalComponent } from './components/atram-modal/atram-modal.component';
import { AtramLoaderComponent } from './components/atram-loader/atram-loader.component';
import { AtramAutocompleteDropdownComponent } from './components/atram-autocomplete-dropdown/atram-autocomplete-dropdown.component';
import { AtramSelectComponent } from './components/atram-select/atram-select.component';

//directives
import { ClicksOutsideDirective } from './directives/clicks-outside.directive';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { UpperCaseDirective } from './directives/uppercase.directive';
import { NoSpecialCharDirective } from './directives/no-special-char.directive';
import { AtramDaterangepickerComponent } from './components/atram-daterangepicker/atram-daterangepicker.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ScrollDirective } from './directives/scroll.directive';
import { AtramCheckboxComponent } from './components/atram-checkbox/atram-checkbox.component';
import { AtramDatepickerComponent } from './components/atram-datepicker/atram-datepicker.component';


@NgModule({
  declarations: [
    AtramButtonComponent,
    ClicksOutsideDirective,
    AtramTextboxComponent,
    NumberOnlyDirective,
    UpperCaseDirective,
    NoSpecialCharDirective,
    AtramOtpTextboxComponent,
    AtramModalComponent,
    AtramLoaderComponent,
    AtramAutocompleteDropdownComponent,
    AtramSelectComponent,
    AtramDaterangepickerComponent,
    ScrollDirective,
    AtramCheckboxComponent,
    AtramDatepickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot()
  ],
  exports: [
    AtramButtonComponent,
    AtramTextboxComponent,
    AtramOtpTextboxComponent,
    AtramModalComponent,
    AtramLoaderComponent,
    AtramAutocompleteDropdownComponent,
    AtramSelectComponent,
    AtramDaterangepickerComponent,
    AtramDatepickerComponent,
    ClicksOutsideDirective,
    AtramCheckboxComponent,
    NumberOnlyDirective,
    UpperCaseDirective,
    NoSpecialCharDirective,
    ScrollDirective 
  ]
})
export class SharedModule { }
